import script from "./collapse-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./collapse-item.vue?vue&type=script&setup=true&lang=ts"

import "./collapse-item.vue?vue&type=style&index=0&id=ad76f2d2&lang=css"

const __exports__ = script;

export default __exports__